import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import numeral from 'numeral';
import { css } from '@bd/bdui-styles/emotion';
import { GoogleMapUrl } from '@bd/bdcore-utilities';
import LightBox from '@bd/bdui-lightbox';
import DetailHeaderWrapper from '../../components/DetailHeaderWrapper';
import { colors, typography } from '../../styles';
import CommunityMenu from './CommunityMenu';

const styles = css`
  .DetailHeader_photoButton {
    position: absolute;
    right: 0;
    top: 100px;
    width: 54px;
    height: 80px;
    background-color: rgba(173,137,47,.9);
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-weight: 800;
    font-size: 18px;
    color:#FFFFFF;
    a {
      color: #FFFFFF;
      &:hover {
        opacity: .8;
      }
    }
    @media (min-width: 992px) {
      top: 50%;
    }
  }
  .DetailHeader_infoWrapper {
    position: relative;
    background-color: rgba(63,63,63,.8);
    width: 100%;
    display: flex;
    flex-direction: column;
    @media (min-width: 992px) {
      position: absolute;
      bottom: 56px;
      left: 0;
      background-color: rgba(63,63,63,.8);
      width: 1120px;
      max-width: 100%;
      flex-direction: row;
    }
  }
  .DetailHeader_heading {
    padding: 20px 20px 30px 20px;
    width: 100%;
    flex-shrink: 0;
    @media (min-width: 992px) {
      padding: 30px 60px;
      width: 60%;
      flex-shrink: 0;
    }
  }
  .DetailHeader_commName {
    font-family: ${typography.Serif};
    font-size: 29px;
    font-weight: 300;
    color: #FFFFFF;
    line-height: 1;
    position: relative;
    margin-bottom: 0.35em;
    @media (min-width: 992px) {
      font-size: 40px;
    }
  }
  .DetailHeader_address {
    font-family: ${typography.SanSerif};
    font-weight: 700;
    font-size: 15px;
    color: ${colors.color3Dark};
    letter-spacing: 0;
    text-transform: uppercase;
    margin-bottom: 0.35em;
    @media (min-width: 992px) {
      font-size: 18px;
    }
  }
  .DetailHeader_phone {
    display: block;
    font-size: 13px;
    @media (min-width: 992px) {
      font-size: 15px;
    }
  }
  .DetailHeader_hours {
    font-size: 13px;
    margin: 0;
    color: white;
    @media (min-width: 992px) {
      font-size: 15px;
    }
  }
  .DetailHeader_info {
    flex-grow: 1;
    background-color: rgba(63,63,63,.6);
    list-style: none;
    color: #FFFFFF;
    padding: 0;
    margin: 0;
    text-align: left;
    @media (min-width: 992px) {
      border-left: ${colors.color5Dark} solid 3px;
    }
    li {
      padding: 15px 20px;
      text-align: left;
      border-bottom: ${colors.color5Dark} solid 1px;
      font-size: 13px;
      line-height: 1;
      display: inline-block;
      width: 100%;
      vertical-align: top;
      a {
        color: #E0CF9B;
        font-weight: 900;
      }
      img {
        margin: 0 10px 0 0;
      }
      @media (min-width: 992px) {
        font-size: 15px;
      }
    }
    .DetailHeader_infoHeadline {
      font-weight: 600;
      font-size: 16px;
      padding: 25px 20px;
      @media (min-width: 992px) {
        font-weight: 300;
        font-size: 22px;
        padding: 25px 20px;
      }
    }
    .DetailHeader_listItemHalf {
      width: 50%;
      border-right: ${colors.color5Dark} solid 1px;
      a {
        display: flex;
        align-items: center;
      }
    }
  }
  .DetailHeader_menuWrapper {
    position: relative;
    height: 56px;
    .DetailHeader_menu {
      background-color: rgba(45,45,45,.9);
      display: flex;
      align-items: center;
      justify-content: center;
      list-style: none;
      padding: 0;
      height: 56px;
      li {
        display: none;
        padding: 0 15px;
        line-height: 56px;
        font-weight: 900;
        flex-grow: 0;
        text-transform: uppercase;
        @media (min-width: 992px) {
          display: inline-block;
        }
        a, .DetailHeader_link {
          cursor: pointer;
          color: ${colors.color1};
        }
      }
    }
    @media (min-width: 992px) {
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 0;
      height: 56px;
      .DetailHeader_menu {
        background-color: rgba(45,45,45,.9);
        line-height: 56px;
        display: flex;
        align-items: center;
        justify-content: center;
        list-style: none;
        padding: 0;
        li {
          line-height: 56px;
          padding: 0 15px;
          font-weight: 900;
          flex-grow: 0;
          text-transform: uppercase;
          a {
            color: ${colors.color1};
          }
        }
      }
    }
  }
  .DetailSection {
    padding: 90px 0;
    img {
      max-width: 100%;
    }
    .DetailSection_heading {
      text-transform: uppercase;
      font-family: ${typography.Serif};
      font-size: 24px;
      font-weight: 300;
      color: ${colors.color5};
      position: relative;
      text-align: center;
      margin: 0 0 60px 0;
      @media (min-width: 992px) {
        margin: 0 0 70px 0;
        font-size: 36px;
      }
      span {
        font-weight: 900;
        color: ${colors.color5Darker};
      }
      &:after {
        content: '';
        width: 180px;
        height: 5px;
        bottom: -30px;
        background-color: ${colors.color2};
        left: 0;
        right: 0;
        margin: 0 auto;
        position: absolute;
        display: block;
      }
    }
  }
  .SitePlan_banner {
    background-image: url('/images/contact-cta-bg.svg');
    background-size: cover;
    padding: 45px;
    text-align: center;
    .SitePlan_bannerTitle {
      font-weight: 800;
      font-size: 18px;
      color: ${colors.color5Lighter};
      letter-spacing: 0;
      text-align: center;
      text-transform: uppercase;
      margin: 0 0 15px 0;
    }
    .SitePlan_bannerPostTitle {
      font-weight: 200;
      font-size: 42px;
      color: ${colors.color1};
    }
    @media (min-width: 992px) {
      .SitePlan_bannerTitle {
        font-size: 21px;
      }
      .SitePlan_bannerPostTitle {
        font-size: 70px;
      }
    }
  }
  .POIMap_wrapper {
    display: flex;
    flex-direction: row-reverse;
  }
  .POIMap_inner {
    width: 30%;
    padding: 50px;
    background-color: ${colors.color3Lighter};
    overflow: hidden;
    overflow-y: scroll;
    height: 600px;
  }
  .POIMap_categories {
    list-style: none;
    padding: 0;
    text-align: left;
    li {
      margin: 0 0 15px 0;
      span {
        cursor: pointer;
        color: ${colors.color5};
      }
    }
    img {
      margin: 0 10px 0 0;
    }
    ul {
      list-style: none;
      padding: 10px 0 0 10px;
      li {
        font-size: 13px;
        font-weight: 600;
      }
    }
  }
  .POIMap_mapWrapper {
    position: relative;
    z-index: 0;
    width: 70%;
    .leaflet-container {
      height: 600px;
    }
  }
`;


function getBedsRange(community) {
  const min = get(community, 'beds_range[0].low');
  const max = get(community, 'beds_range[0].high');
  if (min === max) return `${min} Bedrooms`;
  return `${min} - ${max} Bedrooms`;
}


function CommunityDetailHeader({ community, homes, plans }) {
  return (
    <DetailHeaderWrapper className={styles} imageUrl={get(community, 'photos[0].contentUrl')}>
      <div className="DetailHeader">
        <div className="DetailHeader_infoWrapper">
          <div className="DetailHeader_heading">
            <h1 className="DetailHeader_commName">{get(community, 'name')}</h1>
            <address className="DetailHeader_address">
              {`${get(community, 'address.streetAddress')}, `}
              {`${get(community, 'address.addressLocality')}, ${get(community, 'address.addressRegion')} `}
              {get(community, 'address.postalCode')}
              <span className="DetailHeader_phone">{get(community, 'telephone', '')}</span>
            </address>
            <p className="DetailHeader_hours">{get(community, 'hours')}</p>
          </div>
          <ul className="DetailHeader_info">
            <li className="DetailHeader_infoHeadline">Priced from {numeral(get(community, 'priceLow')).format('$0,0')}</li>
            <li className="DetailHeader_listItemHalf border-right-1">
              {
                getBedsRange(community)
              }
            </li>
            {
              get(community, 'sqftLow') &&
              get(community, 'sqftHigh') &&
              <li className="DetailHeader_listItemHalf border-right-0">
                {numeral(get(community, 'sqftLow')).format('0,0')} - {numeral(get(community, 'sqftHigh')).format('0,0')} SQ FT
              </li>
            }
            {
              get(community, 'pdf_brochure.contentUrl') &&
              <li className="DetailHeader_listItemHalf border-bottom-0">
                <a href={get(community, 'pdf_brochure.contentUrl')} target="_blank" rel="noopener noreferrer">
                  <img src="/images/icon-download-white.svg" alt="" />Download Brochure
                </a>
              </li>
            }
            <li className="DetailHeader_listItemHalf border-right-0 border-bottom-0">
              <a href={GoogleMapUrl(community)} target="_blank" rel="noopener noreferrer">
                <img src="/images/icon-map-pin-white.svg" alt="" />On Map
              </a>
            </li>
          </ul>
        </div>
        <div className="DetailHeader_menuWrapper">
          <CommunityMenu community={community} homes={homes} plans={plans} />
        </div>
        {
          get(community, 'photos', []).length > 0 &&
          <div className="DetailHeader_photoButton">
            <LightBox
              items={get(community, 'photos', [])}
              button={(
                <div>
                  <img src="/images/icon-photos-white.svg" alt="" />
                  <div>{get(community, 'photos', []).length}</div>
                </div>
              )}
            />
          </div>
        }
      </div>
    </DetailHeaderWrapper>
  );
}

CommunityDetailHeader.propTypes = {
  community: PropTypes.object.isRequired,
  plans: PropTypes.arrayOf(PropTypes.object).isRequired,
  homes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData(
  {
    community: true,
    plans: true,
    homes: true,
  },
  {
    required: {
      community: true,
    },
    ifMissing404: true,
  },
)(CommunityDetailHeader);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/CommunityDetailHeader.js